export default __webpack_public_path__ + "static/media/book.a5b275d1.png";